// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"193":"ae586e940fbdb8ad","283":"4cc1ccf2fcf76758","635":"0dd860102eb459ba","672":"9d87f14a445da0ad","715":"3c60f9d15d89e8d8"}[chunkId] + ".js";
};